import GroupsZone from './GroupsZone/index';
import OthersZone from './OthersZone/index';
import AggregatesZone from './AggregatesZone/index';
import CommonDraggableTag from './CommonDraggableTag/index';

export {
  GroupsZone,
  OthersZone,
  AggregatesZone,
  CommonDraggableTag,
};



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/components/index.js